import React from 'react';
import { Link } from 'react-router-dom';
import InternalLink from './InternalLink';

function Navbar({ variant = 'transparent', onlyLogo = false }) {
  return (
    <nav className={`navbar navbar-${variant}`} id="navbar">
      <div className="container nav-container" style={{ justifyContent: onlyLogo ? 'center' : 'space-between' }}>
        <div className="nav-logos-combined">
          <Link to="/" className="logo" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
            <img src="/logo-brain-event.webp" alt="Brain Event" className="logo-img logo-default" />
            <img src="/logo-brain-event-white.webp" alt="Brain Event" className="logo-img logo-white" />
          </Link>
          <span className="logo-separator nav-separator">×</span>
          <Link to="/" className="logo logo-neuros-nav" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
            <img src="/assets/logo-on-black.webp" alt="Neuros" className="logo-img-neuros-nav" />
          </Link>
        </div>
        {!onlyLogo ? (
          <div className="nav-right">
            <div className="nav-badge">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M13 2H3C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V3C14 2.44772 13.5523 2 13 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M11 1V3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5 1V3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M2 5H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
              </svg>
              <span>20 iunie 2026 • București</span>
            </div>

            <div className="timer-mini" id="timerMini">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.5" />
                <path d="M8 5V8L10 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
              </svg>
              <span id="timerMiniText">--:--:--</span>
            </div>

            <InternalLink to="/formular-inscriere" className="btn btn-primary btn-nav">Rezervă locul</InternalLink>
          </div>
        ) : ""}
      </div>
    </nav>
  );
}

export default Navbar;




